import { mountVueComponent } from '@/lib/mount-vue-component';

export default function () {
  import('./GalleryDashboard').then(ScoreSetConfiguration => {
    mountVueComponent('gallery-dashboard', ScoreSetConfiguration);
  });
};

